// for firefox
let isFireFox = navigator.userAgent.match(/Firefox\/([0-9]*)/i);
if( isFireFox && parseInt( isFireFox[1] || 40 ) >= 52 )
{
    console.log('set async')
    window.allow_firefox_cadesplugin_async=1
}

window.jQuery = window.$ =  require("jquery");
window._ =  require("lodash");

Promise.config({
    // Enable cancellation
    cancellation: true
});

// set clientConfig
require( "expose?clientConfig!exports?clientConfig!../config/mdmAliases.template.js");
// reload from server
$.ajax({
    async: false,
    url: "/api/config",
    dataType: "script"
});

require("babel-polyfill");
require("jquery-ui");
require("fastclick");
require("bootstrap");
var moment = require("moment");
require("moment-timezone");
require('moment-precise-range-plugin');
require("fullcalendar");
require("notification");
require("smartwidgets");
require("easy-pie");
require('jvectormap');
require('jvectormap-world-mill-en');
require("jquery-file-download");

moment.locale('ru');
moment.tz.add("Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6")
moment.tz.setDefault("Europe/Moscow");

import * as config from 'config'

window.SMARTADMIN_GLOBALS = config;

//import localStorage from 'localStorage'
//localStorage.clear();

require.ensure([], function(require){
    require('./Router');
});


// WEBPACK FOOTER //
// client/app/main.jsx